import { PartnerEditPage } from "@/features/partner/pages/PartnerEdit";

const PartnerEdit = () => {
  return <PartnerEditPage />;
};

export default PartnerEdit;
